export const notApplicable = 'notApplicable' as const;

export const levelIds = [
	'level0',
	'level1',
	'level2',
	'level3',
	'level4',
	'level5',
	'level6',
	'level7',
] as const;

export const ids = [notApplicable, ...levelIds] as const;
